var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{staticClass:"hover-cursor-pointer",attrs:{"to":{ name: 'Home' }}},[_c('img',{attrs:{"src":require("@/assets/img/diablo-iii.svg"),"alt":"D3","width":"30"}}),_c('span',{staticClass:"font-diablo ml-2"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }